/**
 * Which page an address means.
 *
 * Kept out of `Router.tsx` so the router file exports a component and nothing
 * else, which is what keeps fast refresh working, and so the rule can be tested
 * without rendering anything.
 */

/** Where the planner lives now. `/plan` is kept working, see `canonicalPath`. */
export const PLANNER_PATH = '/';
export const STATUS_PATH = '/status';

/**
 * The path a URL means, after the one piece of history this product carries.
 *
 * The planner was served from `/plan` during the pilot, and the share links
 * people already hold look like `/plan?v=1&from=...`. Those must keep working
 * forever: a shared journey that 404s is worse than never having offered
 * sharing. `/plan` therefore still resolves to the planner, and the query
 * string is never touched, only the path.
 *
 * Anything unrecognised is the planner too. A civic service should answer a
 * mistyped address with the thing people came for, not with a 404.
 */
export function canonicalPath(pathname: string): string {
  if (pathname === '/plan' || pathname.startsWith('/plan/')) return PLANNER_PATH;
  if (pathname === STATUS_PATH || pathname.startsWith('/status/')) return STATUS_PATH;
  return PLANNER_PATH;
}
